export default function formatSeatNumber(value) {
  if (value === undefined || value === null) return '';
  const seat = String(value).trim();
  if (!seat) return '';

  const matches = seat.match(/\d+/g);
  if (matches && matches.length) return matches.join('-');

  const cleaned = seat.replace(/[^0-9-]/g, '').trim();
  return cleaned || seat;
}
